module.exports = __webpack_public_path__ + "img/91fb11e.jpg";